import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Deleted from "../common/Deleted";
import { getMediaDetails } from "../utils";

const MediaDeleted = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, id, updatedBy, updatedAt } = getMediaDetails(log);
  return <Deleted name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default MediaDeleted;
